export const AdminRole = {
    Admin: 'QlubAdmin',
    Analyst: 'QlubAnalyst',
    CountryAnalyst: 'QlubCountryAnalyst',
    Monitor: 'QlubMonitor',
    CountryMonitor: 'QlubCountryMonitor',
    SuperAdmin: 'QlubSuperAdmin',
    Finance: 'QlubFinance',
    QlubTech: 'QlubTech',
};

export const VendorRole = {
    VendorAdmin: 'VendorAdmin',
    BrandAdmin: 'BrandAdmin',
    BrandAnalyst: 'BrandAnalyst',
    VendorAnalyst: 'VendorAnalyst',
    VendorFinance: 'VendorFinance',
    GroupAnalyst: 'GroupAnalyst',
    VendorDevice: 'VendorDevice',
};

// Utility Roles
export const qlubAdminRoles = Object.values(AdminRole);
export const vendorRoles = Object.values(VendorRole);

// Commonly used groupings
const commonVendorRoles = [
    VendorRole.VendorAdmin,
    VendorRole.BrandAdmin,
    VendorRole.BrandAnalyst,
    VendorRole.VendorFinance,
    VendorRole.VendorDevice,
];

const adminAndVendorRoles = [...commonVendorRoles, VendorRole.GroupAnalyst, ...qlubAdminRoles];

// Helper function to generate roles dynamically
const addToCommonRoles = (...additionalRoles: string[]) => [
    ...commonVendorRoles,
    ...additionalRoles,
    ...qlubAdminRoles,
];

export const BrandScheduledReportRole = [VendorRole.BrandAdmin, VendorRole.BrandAnalyst];

export const restrictRoles = {
    HOME: adminAndVendorRoles,
    REPORTS: adminAndVendorRoles,
    TRANSACTIONS: addToCommonRoles(VendorRole.VendorAnalyst, VendorRole.GroupAnalyst),
    PAYMENTS: addToCommonRoles(VendorRole.VendorAnalyst, VendorRole.GroupAnalyst),
    ORDERS_AND_TRANSACTIONS: addToCommonRoles(VendorRole.VendorAnalyst, VendorRole.GroupAnalyst),
    REVIEWS: adminAndVendorRoles,
    NOTIFICATION: addToCommonRoles(VendorRole.VendorAnalyst, VendorRole.GroupAnalyst),
    RESTAURANT_DETAILS: adminAndVendorRoles,
    RESTAURANT_DETAILS_EDIT: addToCommonRoles(AdminRole.Monitor),
    MENUS: addToCommonRoles(VendorRole.VendorAnalyst, VendorRole.GroupAnalyst),
    QR_CODE: adminAndVendorRoles,
    FOODICS: adminAndVendorRoles,
    LS_K_SERIES: adminAndVendorRoles,
    LS_O_SERIES: adminAndVendorRoles,
    VPOS: addToCommonRoles(VendorRole.VendorAnalyst, VendorRole.GroupAnalyst),
    PROFILE_SETTINGS: addToCommonRoles(VendorRole.GroupAnalyst),
    CHANGE_PASSWORD: [
        VendorRole.VendorAdmin,
        VendorRole.BrandAdmin,
        VendorRole.BrandAnalyst,
        VendorRole.VendorFinance,
        VendorRole.GroupAnalyst,
        VendorRole.VendorAnalyst,
    ],
    TABLE_VIEW: addToCommonRoles(VendorRole.VendorAnalyst, VendorRole.GroupAnalyst),
    EXPORT_ORDERS_AND_TRANSACTIONS: adminAndVendorRoles,
    EXPORT_BRAND_REPORTS: BrandScheduledReportRole,
    BRAND_DASHBOARD: BrandScheduledReportRole,
    SCHEDULED_REPORTS: addToCommonRoles(VendorRole.GroupAnalyst),
    REFUND: [VendorRole.BrandAdmin, VendorRole.BrandAnalyst, VendorRole.VendorFinance],
    PAYMENT_LINK: addToCommonRoles(VendorRole.VendorAnalyst, VendorRole.GroupAnalyst),
    BRAND_VERIFICATION_BANNER: addToCommonRoles(VendorRole.VendorDevice),
    LINKIT: addToCommonRoles(VendorRole.GroupAnalyst),
    LOYALTY: [AdminRole.Admin, AdminRole.SuperAdmin, VendorRole.GroupAnalyst],
};
